const GodBlessTheUSA = [
	'[Verse 1]',
	'If tomorrow all the things were gone',
	'I worked for all my life.',
	'And I had to start again',
	'Just my children and my wife.',
	'I thank my lucky stars,',
	'To be living here today.',
	"'Cause the flag still stands for freedom",
	"And they can't take that away",
	'',
	'[Chorus]',
	"I'm proud to be an American",
	"Where at least I know I'm free.",
	"And I won't forget the men who died",
	'And gave that right to me.',
	"And I'll gladly stand up next to you",
	'And defend her still today.',
	"Cause there ain't no doubt I love this land.",
	'God bless the USA!',
	'',
	'[Verse 2]',
	'From the lakes of Minnesota,',
	'To the hills of Tennessee.',
	'Across the plains of Texas,',
	'From sea to shining sea.',
	'From Detroit down to Houston,',
	'And New York to L.A.',
	"There's pride in every American heart",
	"And it's time we stand and say",
	'',
	'[Chorus]',
	"That I'm proud to be an American",
	"Where at least I know I'm free.",
	"And I won't forget the men who died",
	'And gave that right to me.',
	"And I'll gladly stand up next to you",
	'And defend her still today.',
	"Cause there ain't no doubt I love this land.",
	'God bless the USA!',
	'',
	'[Chorus]',
	"I'm proud to be an American",
	"Where at least I know I'm free.",
	"And I won't forget the men who died",
	'And gave that right to me.',
	"And I'll gladly stand up next to you",
	'And defend her still today.',
	"Cause there ain't no doubt I love this land.",
	'God Bless The U - S - A!',
];

export default GodBlessTheUSA;
